<template>
  <el-dialog title="召回原因" :visible.sync="dialogVisible" top="300px" width="400px" @close="handleCancel">
    <el-form ref="recallForm" :model="recallForm" :rules="rules">
      <el-form-item prop="approvalOpinion">
        <el-input v-model="recallForm.approvalOpinion" rows="4" type="textarea" placeholder="请输入召回原因" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="doRecall">
        召回
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { recallInvoiceHasBeenApplied } from '@/API/international';

export default {
  name: 'InternationalRecallDialog',
  props: {
    dialogVisibleFormRecall: {
      type: Boolean,
      default: false
    },
    currentClickData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      recallForm: {
        approvalOpinion: ''
      },
      rules: {
        approvalOpinion: [
          { required: true, message: '请输入召回原因', trigger: 'blur' }
        ]
      },
      dialogVisible: this.dialogVisibleFormRecall
    };
  },
  methods: {
    doRecall () {
      let params = {
        id: this.currentClickData.id,
        approvalOpinion: this.recallForm.approvalOpinion
      };
      this.$refs.recallForm.validate(valid => {
        if (valid) {
          recallInvoiceHasBeenApplied(params).then(res => {
            let json = res.data;
            if (json.status === '200') {
              this.$emit('refresh-table');
              this.clearRecallForm();
              this.dialogVisible = false;
            }
          }).catch(res => {});
        }
      });
    },
    handleCancel () {
      this.recallForm.approvalOpinion = undefined;
    },
    clearRecallForm () {
      this.$refs.recallForm.resetFields();
    }
  },
  watch: {
    dialogVisibleFormRecall (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  }
};
</script>

<style scoped>
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>
